import type { Merge } from 'type-fest';
import * as z from 'zod';
import { parse } from './parser/parse';
import type { TagNodeTree } from './parser/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseAttrs<T extends z.ZodObject<any>>(
    schema: T,
    attrs: Record<string | number, unknown>,
): Merge<
    z.infer<T>,
    {
        __default?: string | null | undefined;
    }
> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value: any = schema.parse(attrs);
    for (const [k, v] of Object.entries(attrs)) {
        if (k === v) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            value['__default'] = z.string().nullish().parse(v);
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return value;
}

export function parseBBcode(input: string): TagNodeTree {
    return parse(input, {
        onlyAllowTags: [
            'b',
            'i',
            'url',
            'img',
            'quote',
            'code',
            'list',
            '*',
            'li',
            'ol',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'p',
            'br',
            'br/',
            'br /',
            'br  /',
            'photo',
            'callToAction',
            'callToActionText',
            'slot',
        ] as const,
    });
}
